<template>
  <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Truck Body -->
    <rect x="10" y="20" width="50" height="20" fill="#007bff" stroke="black" stroke-width="2"/>

    <!-- Truck Cabin -->
    <rect x="60" y="25" width="20" height="15" fill="#ffcc00" stroke="black" stroke-width="2"/>

    <!-- Wheels -->
    <circle cx="20" cy="45" r="5" fill="black">
      <animateTransform attributeName="transform" type="rotate" from="0 20 45" to="360 20 45" dur="1s" repeatCount="indefinite"/>
    </circle>

    <circle cx="60" cy="45" r="5" fill="black">
      <animateTransform attributeName="transform" type="rotate" from="0 60 45" to="360 60 45" dur="1s" repeatCount="indefinite"/>
    </circle>

    <!-- Movement Animation -->
    <animateTransform attributeName="transform" type="translate" values="0 0; 10 0; 0 0" dur="2s" repeatCount="indefinite"/>
  </svg>
</template>
